"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var FA_PREFIXES = ['fa', 'fab', 'fas', 'far', 'fal', 'fad'];
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '2rem',
      height: '2rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  };
});

var Icon = function Icon(_ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["children"]);

  var classes = useStyles();
  var iconName = (Array.isArray(children) ? children.join('') : String(children)).trim();
  var isFontAwesome = FA_PREFIXES.includes(iconName.split(' ')[0]);
  return isFontAwesome ? _react.default.createElement(_core.Icon, _extends({
    classes: classes,
    className: iconName
  }, otherProps)) : _react.default.createElement(_core.Icon, _extends({
    classes: classes
  }, otherProps), iconName);
};

Icon.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]).isRequired
};
var _default = Icon;
exports.default = _default;